<div class="dialog-padding">
  <h1 mat-dialog-title class="dialog-title">Edit Organization Profile</h1>
  <form [formGroup]="editOrganizationRiderForm" (submit)="handleSubmission()">
    <div class="rider-info">
      <div class="organization-and-customerID">
        <!-- Organization -->
        <mat-form-field appearance="outline" class="organization-select-bar">
          <mat-label>Organization</mat-label>
          <mat-select
            id="editOrganizationRider-select-organization"
            name="transitProgramId"
            disabled
            [value]="data.organizationRiderDetail.organizationId"
          >
            <mat-option
              id="editOrganizationRider-option-organization"
              *ngFor="let organization of data.organizations"
              [value]="organization?.id"
            >
              {{ organization.name }} ({{ organization.code }})
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Customer ID -->
        <ng-container *ngIf="!data.organization.partnerIdentifierAutoGenerated; else autoGeneratedPartnerIdentifier">
          <mat-form-field appearance="outline">
            <mat-label>Customer ID</mat-label>
            <input
              id="editOrganizationRider-input-customerId"
              matInput
              type="text"
              formControlName="partnerIdentifier"
              data-private="lipsum"
            />
            <mat-error *ngIf="this.editOrganizationRiderForm.get('partnerIdentifier')?.errors"> No special characters </mat-error>
          </mat-form-field>
        </ng-container>

        <!-- Auto-generated Partner Identifier -->
        <ng-template #autoGeneratedPartnerIdentifier>
          <div>
            <small>Customer ID</small>
            <p id="editOrganizationRider-text-customerId">{{ data.organizationRiderDetail.partnerIdentifier }}</p>
          </div>
        </ng-template>
      </div>

      <div class="ambulatory">
        <!-- Organization Service Levels -->
        <uz-organization-rider-service-levels
          [organizationServiceLevels]="data.organizationServiceLevels"
          [organizationRiderServiceLevels]="data.organizationRiderDetail.organizationRiderServiceLevels"
          (organizationServiceLevelChange)="handleOrganizationServiceLevelChange($event)"
        >
        </uz-organization-rider-service-levels>
      </div>

      <!-- Fist Name -->
      <mat-form-field appearance="outline">
        <mat-label>First Name</mat-label>
        <input
          id="editOrganizationRider-input-firstName"
          matInput
          type="text"
          placeholder="First Name"
          formControlName="firstName"
          data-private="lipsum"
        />
      </mat-form-field>

      <!-- Last Name -->
      <mat-form-field appearance="outline">
        <mat-label>Last Name</mat-label>
        <input
          id="editOrganizationRider-input-lastName"
          matInput
          type="text"
          placeholder="Last Name"
          formControlName="lastName"
          data-private="lipsum"
        />
      </mat-form-field>

      <!-- Email Address -->
      <mat-form-field
        class="email"
        appearance="outline"
        [actionTooltip]="emailTooltipDescription"
        [actionTooltipButtonText]="'Decline'"
        [actionTooltipShow]="shouldShowDeclineTooltip && !editOrganizationRiderForm.get('emailAddress')?.dirty"
        [actionTooltipButtonCallback]="tooltipDismissCallback"
        [subscriptSizing]="shouldShowEmailDeclineSubtext ? 'dynamic' : 'fixed'"
      >
        <mat-label>Email Address</mat-label>

        <input
          id="editOrganizationRider-input-emailAddress"
          matInput
          type="text"
          placeholder="Email Address"
          formControlName="emailAddress"
          data-private="lipsum"
        />
        <mat-hint id="editOrganizationRider-email-text-declinedOn" class="spacer" *ngIf="shouldShowEmailDeclineSubtext">
          Declined on {{ data.organizationRiderDetail.riderEmailDeclinedAt | date : 'short' }}
        </mat-hint>
      </mat-form-field>

      <!-- Phone Number -->
      <mat-form-field appearance="outline" [subscriptSizing]="invalidPhoneNumber ? 'dynamic' : 'fixed'">
        <mat-label>Phone Number</mat-label>
        <input
          id="editOrganizationRider-input-phoneNumber"
          matInput
          type="text"
          placeholder="Phone Number"
          formControlName="phoneNumber"
          uzPhoneNumberInput
          data-private="lipsum"
        />
        <mat-hint class="text-danger" *ngIf="invalidPhoneNumber">
          This phone number needs updating. Please edit and save to store the correct value in our system
        </mat-hint>
      </mat-form-field>

      <!-- Date of Birth -->
      <mat-form-field appearance="outline" (click)="picker.open()" class="date-of-birth">
        <mat-label>Date of Birth</mat-label>
        <input
          id="editOrganizationRider-date-dateOfBirth"
          matInput
          [matDatepicker]="picker"
          name="dateOfBirth"
          formControlName="dateOfBirth"
          data-private="lipsum"
        />
        <mat-icon matSuffix class="material-icons-two-tone">calendar_today</mat-icon>
        <mat-datepicker #picker></mat-datepicker>
        <mat-hint class="date-of-birth-hint">e.g. mm/dd/yyyy</mat-hint>
      </mat-form-field>
      <mat-error
        *ngIf="editOrganizationRiderForm.get('dateOfBirth')?.errors"
        id="editOrganizationRider-error-text"
        class="date-of-birth-error"
      >
        Please enter a valid date of birth
      </mat-error>

      <!-- Rider Pool -->
      <ng-container *ngIf="shouldShowOrganizationRiderPoolSelection()">
        <mat-form-field appearance="outline" class="rider-pool">
          <mat-label>Rider Pool</mat-label>
          <mat-select id="editOrganizationRider-select-riderPool" formControlName="organizationRiderPool" placeholder="Rider Pool">
            <mat-option
              id="editOrganizationRider-option-riderPool-{{ i }}"
              *ngFor="let organizationRiderPool of organizationRiderPools; let i = index"
              [value]="organizationRiderPool"
            >
              {{ getOrganizationRiderPoolDisplayText(organizationRiderPool) }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ng-container>
    </div>

    <mat-dialog-actions align="end">
      <button id="editOrganizationRider-button-cancel" mat-raised-button mat-dialog-close>Cancel</button>
      <button
        id="editOrganizationRider-button-save"
        mat-raised-button
        color="primary"
        type="submit"
        [disabled]="editOrganizationRiderForm.invalid"
      >
        Save
      </button>
    </mat-dialog-actions>
  </form>
</div>
